import React from 'react';
import MuiBadge from '@material-ui/core/Badge';
import MuiListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import { styled } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import { THEME } from 'GlobalStyles';

const DEFAULT_ICON_SIZE = 16;
const BORDER_STYLE = `1px solid ${THEME.palette.customColors.borderColor}`;
const TRUNCATE_STYLE = {
  display: '-webkit-box',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  WebkitBoxOrient: 'vertical',
  WebkitLineClamp: 2
};

export const ListItem = styled(MuiListItem)({
  borderTop: BORDER_STYLE,
  backgroundColor: 'transparent'
});

export const Header = styled('div')(({ theme }) => ({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  marginBottom: theme.spacing(1),
  '& > p': {
    display: 'flex'
  }
}));

export const ContactName = styled('span')(({ theme }) => ({
  fontWeight: THEME.typography.fontWeightBold,
  marginRight: theme.spacing(1),
  maxWidth: '20ch',
  textOverflow: 'ellipsis',
  display: 'inline-block',
  whiteSpace: 'nowrap',
  overflow: 'hidden'
}));

export const ContentContainer = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  paddingRight: theme.spacing(0.5)
}));

export const MessageContainer = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: theme.spacing(1)
}));

export const MessageText = styled(({ shouldTruncate: _shouldTruncate, ...other }) => (
  <Typography {...other} />
))(({ theme, shouldTruncate }) => ({
  whiteSpace: 'pre-wrap',
  paddingRight: theme.spacing(0.5),
  '& em': {
    fontStyle: 'normal',
    fontWeight: theme.typography.fontWeightBold
  },
  '& .draft-label': {
    fontWeight: theme.typography.fontWeightMedium,
    color: theme.palette.primary.main
  },
  ...(shouldTruncate && TRUNCATE_STYLE)
}));

export const AlternateMessage = styled(Typography)({
  ...TRUNCATE_STYLE,
  WebkitLineClamp: 1
});

export const Badge = styled(MuiBadge)(({ theme }) => ({
  marginRight: theme.spacing(1)
}));

export const IconContainer = styled('div')({
  '& > svg': {
    width: DEFAULT_ICON_SIZE,
    height: DEFAULT_ICON_SIZE
  },
  fontSize: DEFAULT_ICON_SIZE,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center'
});

export const StyledListItemIcon = styled(ListItemIcon)({
  minWidth: 48
});
